import { create } from 'zustand';

type ReportDateFilter =
  | { start: string; end: string }
  | { operator?: string; value?: unknown }
  | undefined;

interface InvoiceStatementsStore {
  client: string | null;
  setClient: (client: string | null) => void;
  handleClientClick: (client: { accountId: string; name?: string }) => void;
  resetReportClientFilter: () => void;
  // Exposed sheet context for children to consume
  reportData?: any;
  reportAllowedDateRange?: ReportDateFilter;
  sharedReport?: boolean;
}

export const useInvoiceStatementsStore = create<InvoiceStatementsStore>(
  (set) => ({
    client: null,
    setClient: (client) => set({ client }),
    clientName: '',
    setClientName: (clientName) => set({ clientName }),
    reportData: undefined,
    reportAllowedDateRange: undefined,
    sharedReport: false,
    handleClientClick: () => {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn(
          'useInvoiceStatementsStore.handleClientClick is not initialized'
        );
      }
    },
    resetReportClientFilter: () => {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn(
          'useInvoiceStatementsStore.resetReportClientFilter is not initialized'
        );
      }
    },
    previewTabIndex: 0,
    setPreviewTabIndex: (previewTabIndex) => set({ previewTabIndex })
  })
);
